import { IAddress } from 'models/Address';

export const formatAddressString = (address: IAddress) => `${address.address}, ${address.city}, ${address.state}, ${address.zip}`;
